// apiUtils.ts
import axios from "axios";
import { matchPath, useNavigate } from "react-router-dom";
import { routePaths } from "../routes/routePaths";
import { useAuthentication } from "../hooks/useAuthentication";

export const handleRequestError = (
  error: unknown,
  navigate: ReturnType<typeof useNavigate>,
  logout: ReturnType<typeof useAuthentication>["logout"]
): string => {
  if (axios.isAxiosError(error)) {
    if (error.response) {
      if (error.response.status === 401 || error.response.status === 403) {
        if (!matchPath(window.location.pathname, routePaths.login)) {
          logout();
        }
        return error.response.data;
      }
      return error.response.data?.message || "Грешка в сървъра.";
    } else if (error.request) {
      navigate(routePaths.serverErrorPage);
    }
  }
  if (error instanceof Error) {
    return error.message;
  }
  return "Възникна грешка.";
};

export const toCamelCase = (str: string): string => {
  return str.charAt(0).toLowerCase() + str.slice(1);
};

export const keysToCamelCase = (obj: any): any => {
  if (Array.isArray(obj)) {
    return obj.map((item) => keysToCamelCase(item));
  } else if (obj !== null && typeof obj === "object") {
    return Object.keys(obj).reduce((result: any, key: string) => {
      const camelCaseKey = toCamelCase(key);
      result[camelCaseKey] = keysToCamelCase(obj[key]);
      return result;
    }, {});
  }
  return obj;
};
